import { FC, useEffect } from 'react'
import { FormLabel, rgbToHex } from '@mui/material'
import { HexColorPicker } from 'react-colorful'
import { RadioGroup } from 'entities/RadioGroup'
import { GridDiv } from 'entities/GridDiv'
import { colorOptions } from './options'
import { Input } from 'entities/Input'

import { useConfigStore } from 'shared/store/configSlice'

import { ColorGroupContainer, ColorPickerContainer } from './styled'

export const ColorPicker: FC<ColorPickerType> = ({ color, updateColorHandler }) => {
  const isConfigLoaded = useConfigStore().isConfigLoaded

  useEffect(() => {
    if (!color && isConfigLoaded) {
      updateColor(colorOptions?.[0]?.value)
    }
  }, [color, isConfigLoaded])

  const updateColor = (value: string) => {
    updateColorHandler({ colour: value })
  }

  const handleHexPicker = () => {
    const element = Array.from(
      document.getElementsByClassName(
        'react-colorful__pointer-fill'
      ) as HTMLCollectionOf<HTMLElement>
    )[0]
    updateColor(rgbToHex(element?.style?.backgroundColor))
  }

  return (
    <ColorPickerContainer>
      <FormLabel id='color_picker-label'>Accent color</FormLabel>
      <GridDiv $gc='1/2'>
        <ColorGroupContainer>
          <RadioGroup
            key={`color_picker_radio_${color}`}
            options={colorOptions}
            value={color}
            handleChange={updateColor}
            sx={{
              width: '355px',
              display: 'grid',
              gap: '8px',
              gridTemplateColumns: 'repeat(auto-fill, 100px)'
            }}
          />
          <Input
            key={`color_picker_input_${color}`}
            defaultValue={color}
            placeholder='Color'
            width='100%'
            onBlur={updateColor}
          />
        </ColorGroupContainer>
      </GridDiv>
      <GridDiv $gc='2/-1'>
        {/* HexColorPicker styles are overwritten in index.css */}
        <HexColorPicker
          key={`color_picker_hex_${color}`}
          color={color || colorOptions?.[0]?.value}
          onMouseUp={handleHexPicker}
        />
      </GridDiv>
    </ColorPickerContainer>
  )
}

type ColorPickerType = {
  color: string
  updateColorHandler: (value: { colour: string }) => void
}
